export default __webpack_public_path__ + "static/media/iconDownloadVisualizar.8c88b0cb.svg";